// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { useEffect, useState } from 'react';
import { forgetSignedOutNotice, readSignedOutNotice } from '../signedOutNotice';

// The note another tab's sign-out left for this page, read once
// eslint-disable-next-line import/prefer-default-export
export const useSignedOutNotice = () => {
  const [notice] = useState(readSignedOutNotice);

  useEffect(() => {
    forgetSignedOutNotice();
  }, []);

  return notice;
};
